// remarkCenterDirective.js
import { visit } from "unist-util-visit";

export function remarkCenterDirective() {
  return (tree) => {
    visit(tree, (node) => {
      if (
        node.type === "containerDirective" &&
        node.name === "center"
      ) {
        const data = node.data || (node.data = {});
        data.hName = "div";
        data.hProperties = { className: "text-center my-2" };
      }
    });
  };
}
